@if (isVisible$$()) {
  <div class="offline-banner" [attr.data-state]="offlineBannerState$$()" role="status" aria-live="polite" [attr.aria-atomic]="true">
    <span class="banner-text">{{ message$$() | transloco }}</span>
  </div>
}
